module.exports = __webpack_public_path__ + "static/off-91bca3daba5b0e5e791fead479b2c2ba.png";